import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=5e6e82e6&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"
import style0 from "./Error404.vue?vue&type=style&index=0&id=5e6e82e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports